import React, { useMemo } from 'react'
import { withFormik } from 'formik'
import { Button, Column, Grid, TextField, TextInput } from '../../../../views/components'
import styles from './EditPropertyForm.module.scss'
import { TextFieldTypes } from 'views/components/atoms/TextField/text-field.types'
import { isEmpty } from 'ramda'

const EditPropertyForm = ({
  onCancel,
  isReadOnly,
  initialValues,
  values,
  handleSubmit,
  handleChange,
  handleBlur,
}: any) => {
  const isUnitBuildingEditable = useMemo(() => {
    if (initialValues.placeId !== undefined) return true
    return !isEmpty(initialValues.schemeNumber) && !isEmpty(initialValues.schemeName)
  }, [initialValues.placeId, initialValues.schemeNumber, initialValues.schemeName])

  return (
    <div className={styles.root}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <fieldset disabled={isReadOnly}>
          <div className={styles.body}>
            <Grid>
              <Column xs={12} md={4} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput
                      type={TextFieldTypes.text}
                      name="unitNumber"
                      placeholder="e.g. 4"
                      value={values.unitNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!isUnitBuildingEditable}
                    />
                  }
                  label="Unit Number (if Applicable)"
                />
              </Column>
              <Column xs={12} md={8} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput
                      type={TextFieldTypes.text}
                      name="buildingName"
                      placeholder="e.g. Cardiff Castle"
                      value={values.buildingName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!isUnitBuildingEditable}
                    />
                  }
                  label="Building / Complex Name (if Applicable)"
                />
              </Column>
            </Grid>
            <Grid>
              <Column xs={12} md={4} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput
                      type={TextFieldTypes.text}
                      name="schemeNumber"
                      value={values.schemeNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={true}
                    />
                  }
                  label="Sectional Scheme Number"
                />
              </Column>
              <Column xs={12} md={8} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput
                      type={TextFieldTypes.text}
                      name="schemeName"
                      value={values.schemeName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={true}
                    />
                  }
                  label="Sectional Scheme Name"
                />
              </Column>
            </Grid>
            <Grid>
              <Column xs={12} md={8} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput type={TextFieldTypes.text} name="streetAddress" value={values.streetAddress} disabled />
                  }
                  label="Street Address"
                  disabled
                />
              </Column>

              <Column xs={12} md={4} flexOptions="padding-r-1">
                <TextField
                  inputComponent={<TextInput type={TextFieldTypes.text} name="city" value={values.city} disabled />}
                  label="City / Municipality"
                  disabled
                />
              </Column>
              <Column xs={12} md={4} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput type={TextFieldTypes.text} name="province" value={values.province} disabled />
                  }
                  label="Province"
                  disabled
                />
              </Column>
              <Column xs={12} md={4} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput type={TextFieldTypes.text} name="postalCode" value={values.postalCode} disabled />
                  }
                  label="Postal Code"
                  disabled
                />
              </Column>
              <Column xs={12} md={4} flexOptions="padding-r-1">
                <TextField
                  inputComponent={
                    <TextInput type={TextFieldTypes.text} name="country" value={values.country} disabled />
                  }
                  label="Country"
                  disabled
                />
              </Column>
            </Grid>
          </div>
          <div className={styles.footer}>
            <Button type="submit">Save</Button>
            <Button secondary onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </fieldset>
      </form>
    </div>
  )
}

export default withFormik({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '({ initialValues }: { initialValues: any; })... Remove this comment to see the full error message
  mapPropsToValues: ({ initialValues }) => initialValues,
  // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
  handleSubmit: (values, { props }) => props.handleSubmit(values),
})(EditPropertyForm)
